module.exports = __webpack_public_path__ + "media/auto_data/check-off@2x-8419beea.png";